import React, { useState, useEffect } from 'react';

import { ModalCenterFont, Textarea } from './styles';
import FailIcon from '../../../assets/fail_icon.png';

//import '../../../../node_modules/@govbr/dsgov/dist/dsgov.min.css';

function ModalConfirmAgencyEntityBlock(props) {
    const [showErroBlockMotive, setShowErroBlockMotive] = useState(false);

    useEffect(()=>{
        document.getElementById("motivo_bloqueio").value = "";    
    }, [props.appear])
    
    return(
        <ModalCenterFont appear={props.appear}>
            <div className="br-modal is-large" id="modal">
                <div className="br-card">
                    <div className="container-fluid p-4">
                        <div className="br-modal-header">
                            <div
                                className="br-modal-title"
                                title="Retornar para página inicial?"
                            >
                                <strong>{props.title}</strong>
                            </div>
                        </div>
                        {/* <div className='br-modal-body' >{text}</div> */}
                        <div className="br-modal-body">
                            <div style={{"overflowWrap": "anywhere", "whiteSpace": "normal"}} dangerouslySetInnerHTML={{ __html: props.text }} />
                            <label> Motivo do bloqueio </label>
                            <Textarea id="motivo_bloqueio" name="motivo_bloqueio"
                                onChange={(event) => {
                                    setShowErroBlockMotive(false);
                                    props.setSelectedAgency(prev => ({
                                        ...prev, motivo_bloqueio: event.target.value}) 
                                    );
                                }}
                                rows="4" cols="200"/>
                            {showErroBlockMotive &&
                                <span className="feedback danger" role="alert">
                                    <i className="fas fa-times-circle" aria-hidden="true">
                                        <img
                                            src={FailIcon}
                                            style={{ paddingBottom: '5px' }}
                                            alt="failicon"
                                        />
                                    </i>
                                    Este campo é obrigatório.
                                </span>
                            }
                        </div>
                        <div className="br-modal-footer justify-content-end">
                            <button className="br-button secondary small m-2" type="button" onClick={props.actionButton1}>
                                {props.textButton1}
                            </button>
                            <button className="br-button primary small m-2" type="button" onClick={() => {
                                    const motivo = document.getElementById("motivo_bloqueio").value;                              
                                    if (motivo?.trim().length > 0) {
                                        props.actionButton2();
                                    } else {
                                        setShowErroBlockMotive(true);
                                    }                                                                           
                                }}>
                                {props.textButton2}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </ModalCenterFont>
    );
}

export default ModalConfirmAgencyEntityBlock;